import { Directive, ElementRef, Input, OnInit, OnDestroy } from '@angular/core';
import flatpickr from 'flatpickr';

@Directive({
  selector: '[mwlFlatpickr]',
  standalone: false,
})
export class FlatpickrDirective implements OnInit, OnDestroy {
  @Input() convertModelValue: boolean = false;
  @Input() options: any = {};

  private flatpickrInstance: any;

  constructor(private elementRef: ElementRef) {}

  ngOnInit() {
    const defaultOptions = {
      dateFormat: 'Y-m-d',
      allowInput: true,
      clickOpens: true,
      ...this.options
    };

    this.flatpickrInstance = flatpickr(this.elementRef.nativeElement, defaultOptions);
  }

  ngOnDestroy() {
    if (this.flatpickrInstance) {
      this.flatpickrInstance.destroy();
    }
  }
} 